module.exports = __webpack_public_path__ + "images/huazhu4.jpg?v=e84793bd";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/huazhu4.jpg
 ** module id = 109
 ** module chunks = 1 2
 **/